export default __webpack_public_path__ + "static/media/step5.7d224b8b.png";